/**
 * Les minuteries de la démo, et leur balai.
 *
 * Un scénario programme des choses à quelques secondes de distance (Cyrano
 * qui lit, puis écrit, puis envoie). Si on quitte le mode démo — ou si on
 * recharge le monde — au milieu d'une séquence, ce qui restait en vol doit
 * mourir : sinon un message d'une conversation qui n'existe plus arrive dans
 * le fil d'à côté.
 *
 * D'où ce registre minuscule : tout `setTimeout` de la démo passe par ici, et
 * `toutAnnuler()` referme la maison d'un coup.
 */

const enVol = new Set<ReturnType<typeof setTimeout>>();

/**
 * `setTimeout`, mais annulable en masse — et, depuis le 20-08, annulable SEUL.
 *
 * La poignée rendue sert au fan de la démo : trois envois qui se suivent (la
 * carte du menu, puis les deux bulles qui la commentent) ne doivent produire
 * qu'UNE réponse. Sans elle, on ne pouvait qu'ajouter des réponses, jamais
 * repousser celle qui était déjà en vol.
 */
export function plusTard(fn: () => void, delaiMs: number): () => void {
  const id = setTimeout(() => {
    enVol.delete(id);
    fn();
  }, delaiMs);
  enVol.add(id);
  return () => {
    clearTimeout(id);
    enVol.delete(id);
  };
}

/** Annule tout ce qui était programmé et n'est pas encore parti. */
export function toutAnnuler(): void {
  for (const id of enVol) clearTimeout(id);
  enVol.clear();
}
